import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`13-08-2022`}</h1>
    <ul>
      <li parentName="ul">{`Main Insights wrt gatsby and creating blogs with authors`}
        <ul parentName="li">
          <li parentName="ul">{`Setup a `}<a parentName="li" {...{
              "href": "https://github.com/tattle-made/website/commit/5280aab81432544def4f94c49749fab0937e3163"
            }}>{`wip setup`}</a>{` to create pages for blog, people and projects`}</li>
          <li parentName="ul">{`blogs can be mdx, authors should be json or yaml.`}
            <ul parentName="li">
              <li parentName="ul">{`the transformer plugins for them will create nodes with the relevant fields being at root level. if i model them as frontmatter in an mdx file, it makes the datastructure very nested and hence hard to link with another field`}</li>
            </ul>
          </li>
          <li parentName="ul">{`Setting up foreign keys on gatsby via @link directive`}
            <ul parentName="li">
              <li parentName="ul">{`gatsby @link directive tutorials`}
                <ul parentName="li">
                  <li parentName="ul"><a parentName="li" {...{
                      "href": "https://hashinteractive.com/blog/gatsby-data-relationships-with-foreign-key-fields/"
                    }}>{`detailed blog post`}</a></li>
                  <li parentName="ul"><a parentName="li" {...{
                      "href": "https://github.com/gatsbyjs/gatsby/issues/24791"
                    }}>{`github issue`}</a></li>
                </ul>
              </li>
            </ul>
          </li>
          <li parentName="ul">{`Useful `}<a parentName="li" {...{
              "href": "https://www.youtube.com/playlist?list=PLW0RabRDhwwzVNhlOgQQgw6HJzXdM1MnT"
            }}>{`video lectures`}</a>{` on building a blog with gatsby`}</li>
        </ul>
      </li>
      <li parentName="ul">{`People page`}
        <ul parentName="li">
          <li parentName="ul">{`added a `}<a parentName="li" {...{
              "href": "https://github.com/tattle-made/website/issues/75"
            }}>{`github issue`}</a>{` documenting some nice to have features`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Added gatsby snippets to [`}{`[gatsby]`}{`]`}</li>
      <li parentName="ul">{`Added a `}<a parentName="li" {...{
          "href": "https://github.com/tattle-made/website/issues/76"
        }}>{`github issue`}</a>{` about allowing tattle team members to preview the website before pushing`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      